import React from 'react';
import PlanningTemplates from '../company/PlanningTemplates';

const SuperadminPlanningTemplates = (props) => (
  <PlanningTemplates {...props} isSystem />
);

export default SuperadminPlanningTemplates;
